<template>
	<div class="simulado-container">
		<div class="simulado-label">
			<i data-v-062c5328="" class="material-icons squaredMaterial">spellcheck</i>
			<span>{{name}}</span>
			<!-- <span class='aviso' v-if="isEmpty">{{`Não existem questões do tipo ${name} cadastradas para esse objeto.`}}</span> -->
		</div>
		<div class="simulado-data">
			<div class="label">Defina a quantidade de questões:</div>
			<numberBox :default="qtdDefault" :prefix="`${prefix}_${type}`" :key="key" :eventBus="true" :disabled="disabled"/>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EventBus from '@/components/event-bus.js'
import NumberBox from '@/components/shared/NumberBox'

export default {
	name: 'exibeTipoQuestoes',
	components: { NumberBox },
	props: ['name', 'label', 'prefix', 'qtdDefault', 'type', 'dirty', 'disabled'],
	data () {
		return { key: 0 }
	},
	created () {
		EventBus.$on(`inputBus-${this.$props.prefix}_${this.$props.type}`, this.listener)
	},
	computed: {
		...mapGetters(['isEmpty'])
	},
	methods: {
		...mapActions(['updateQtdQuestions']),
		listener (payload) {
			const dirty = payload !== this.$props.qtdOriginal
			const data = { tipoQuestaoId: this.$props.label, qtd: payload, type: this.$props.type, dirty }
			this.updateQtdQuestions(data)
		}
	},
	watch: {
		qtdDefault () {
			this.key = this.$props.qtdDefault
		}
	}
}
</script>

<style lang="scss" scoped>
	.simulado-container {
		grid-column: 1/5 !important;
		padding: 5px;
		grid-area: form-container-area-12;
		.simulado-label {
			border-bottom: solid 2px $success-color;
			height: 30px;
			color: $success-color;
			margin-bottom: 8px;
			display: flex;
			align-items: center;
			.aviso {
				margin-left: 15px;
				color: rgb(134, 18, 18);
				font-size: 12px;
			}
			i{
				font-size: 22px;
				margin-right: 5px;
			}
			.area-2 {
				background-color: $success-color;
			}
		}

		.simulado-data {
			display: inline-flex;
			width: 100%;
			height: 30px;
			div:last-of-type {
				margin-right: auto;
			}
			.label {
				background-color: $inputs-color;
				width: fit-content;
				padding: 5px;
				border-radius: 4px;
				font-size: $font-size-placeholder;
			}

			.questoes {
				float: right;
				.btns-container {
					button {
						padding: 6px 10px;
						border-radius: 6px;
						background: $main-color;
						color: #fff;
						border: none;
						text-transform: uppercase;
						font-weight: $font-weight-default-bolder;
						font-size: .9em;
						cursor: pointer;
						outline: none;
						&:disabled {
							background: #dddddd;
							cursor: default;
						}
					}
					button:last-child {
						margin-left: 10px;
					}
				}

			}
		}
	}
</style>
